import styled from "styled-components";
import { Link } from "react-router-dom";

interface UserButtonProps {
  isLoggedIn: boolean;
  username?: string;
  onLogout?: () => void;
}

const StyledUserButton = styled(Link)`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  color: white;
  text-decoration: none;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.8;
  }

  @media (max-width: 767px) {
    padding: 8px 4px;
  }
`;

const UserIcon = styled.div`
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 30px;
    height: 30px;
  }

  @media (max-width: 767px) {
    width: 36px;
    height: 36px;

    svg {
      width: 36px;
      height: 36px;
    }
  }
`;

const Username = styled.span`
  font-size: 14px;

  @media (max-width: 767px) {
    display: none;
  }
`;

// Simple user icon SVG
const UserIconSVG = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z"
      fill="currentColor"
    />
  </svg>
);

export const UserButton = ({ isLoggedIn, username }: UserButtonProps) => {
  if (isLoggedIn && username) {
    return (
      <StyledUserButton to="/account">
        <UserIcon>
          <UserIconSVG />
        </UserIcon>
        <Username>{username}</Username>
      </StyledUserButton>
    );
  }

  return (
    <StyledUserButton to="/login">
      <UserIcon>
        <UserIconSVG />
      </UserIcon>
      <Username>Accedi</Username>
    </StyledUserButton>
  );
};
